import { ListAgents } from '../components/agent';
import { LeftNav } from '../components/nav';

export default function Agents() {
  return (
    <LeftNav>
      <h2>Agents</h2>
      <ListAgents />
    </LeftNav>
  );
}
